import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback, useState } from 'react';
import { components } from '@atlaskit/select';
import Spinner from '@atlaskit/spinner'; // TODO: FORM-629 Analytics:
// import { useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';

// import { sendAnalytics } from '../../../common/utils';
import ErrorMessage from './error-message';
import LoadingMessage from './loading-message';
import ShowMoreButton from './show-more-button';
import { LoadingWrapper } from './styled';
export var MenuList = function MenuList(props) {
  // const { createAnalyticsEvent } = useAnalyticsEvents();
  var _useState = useState(1),
      _useState2 = _slicedToArray(_useState, 2),
      clickCount = _useState2[0],
      setClickCount = _useState2[1];

  var _props$selectProps$me = props.selectProps.menuListProps,
      _props$selectProps$me2 = _props$selectProps$me.error,
      isError = _props$selectProps$me2.isError,
      onRetry = _props$selectProps$me2.onRetry,
      handleShowMore = _props$selectProps$me.handleShowMore,
      isLoading = _props$selectProps$me.isLoading,
      isPaginationLoading = _props$selectProps$me.isPaginationLoading,
      showShowMoreButton = _props$selectProps$me.showShowMoreButton;
  var handleOnShowMore = useCallback(function () {
    setClickCount(clickCount + 1); // sendAnalytics({
    //   actionSubjectId: 'filterSearchShowMore',
    //   createAnalyticsEvent,
    //   type,
    //   clickCount,
    // });

    handleShowMore();
  }, [clickCount, handleShowMore]);

  if (isLoading && clickCount > 1) {
    setClickCount(1);
  }

  return /*#__PURE__*/React.createElement(components.MenuList, props, isLoading ? /*#__PURE__*/React.createElement(LoadingMessage, null) : isError ? /*#__PURE__*/React.createElement(ErrorMessage, {
    onRetry: onRetry
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, props.children, isPaginationLoading ? /*#__PURE__*/React.createElement(LoadingWrapper, null, /*#__PURE__*/React.createElement(Spinner, null)) : showShowMoreButton && /*#__PURE__*/React.createElement(ShowMoreButton, {
    onShowMore: handleOnShowMore
  })));
};
export default MenuList;